import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=15468aa1&"
import script from "./checkout.vue?vue&type=script&lang=ts&"
export * from "./checkout.vue?vue&type=script&lang=ts&"
import style0 from "./checkout.vue?vue&type=style&index=0&id=15468aa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports